/**
 * Beacon dei KPI (QA26-F5.4): il frontend dice al backend cosa è successo (lista chiusa BeaconIn di @qa/shared), il
 * backend aggiunge l'utente dalla sessione e inoltra ad agent-runtime. Fire-and-forget: non lancia mai e non blocca
 * l'interfaccia. Solo etichette e numeri.
 */
import type { BeaconIn } from "@qa/shared";
import { apiUrl } from "../api/client";

type Evento = BeaconIn["evento"];
type Dati<E extends Evento> = Omit<Extract<BeaconIn, { evento: E }>, "evento">;

export function traccia<E extends Evento>(evento: E, ...dati: keyof Dati<E> extends never ? [] : [Dati<E>]) {
  try {
    void fetch(apiUrl("/usage"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ evento, ...(dati[0] ?? {}) }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // mai un errore all'utente per una metrica
  }
}
